/**
 * Binding entre la valeur des filtres de la barre de recherche
 * et leur label
 */
export const defaultFilters = [
  {
    label: 'À picker',
    value: 'picking_required'
  },
  {
    label: 'Adresse à corriger',
    value: 'address_to_be_corrected'
  },
  {
    label: 'En cours de prépicking',
    value: 'prepicker'
  },
  {
    label: 'En cours de picking',
    value: 'picker'
  },
  {
    label: 'En rupture de stock',
    value: 'out_of_stock'
  },
  {
    label: 'Picking en pause',
    value: 'picking_paused'
  },
  {
    label: 'En attente de coursier',
    value: 'waiting_for_courier'
  },
  {
    label: 'Ramassée',
    value: 'courier'
  },
  {
    label: 'À emballer',
    value: 'packing_required'
  },
  {
    label: "En cours d'emballage",
    value: 'packer'
  },
  {
    label: 'Emballage en pause',
    value: 'packing_paused'
  },
  {
    label: 'Emballage terminé',
    value: 'packing_finished'
  },
  {
    label: 'Prête à être expédiée',
    value: 'ready'
  },
  {
    label: 'Donnée au transporteur',
    value: 'given_to_carrier'
  },
  {
    label: 'Scannée par le transporteur',
    value: 'scanned_by_carrier'
  },
  {
    label: 'Livrée',
    value: 'delivered'
  },
  {
    label: 'Livraison échouée',
    value: 'delivery_failed'
  },
  {
    label: 'Retournée',
    value: 'returned'
  },
  {
    label: 'Annulée',
    value: 'cancelled'
  },
  {
    label: 'Perdue',
    value: 'lost'
  },
  {
    label: 'Brouillon',
    value: 'draft'
  }
];

export const notSentFilter = [
  {
    label: 'En attente de coursier',
    value: 'waiting_for_courier'
  },
  {
    label: 'Brouillon',
    value: 'draft'
  }
];

export const expeditionsFilters = [
  {
    label: 'Adresse à corriger',
    value: 'address_to_be_corrected'
  },
  {
    label: 'À picker',
    value: 'picking_required'
  },
  {
    label: 'En cours de prépicking',
    value: 'prepicker'
  },
  {
    label: 'En cours de picking',
    value: 'picker'
  },
  {
    label: 'En rupture de stock',
    value: 'out_of_stock'
  },
  {
    label: 'Picking en pause',
    value: 'picking_paused'
  },
  {
    label: 'Ramassée',
    value: 'courier'
  },
  {
    label: 'À emballer',
    value: 'packing_required'
  },
  {
    label: "En cours d'emballage",
    value: 'packer'
  },
  {
    label: 'Emballage en pause',
    value: 'packing_paused'
  },
  {
    label: 'Emballage terminé',
    value: 'packing_finished'
  },
  {
    label: 'Prête à être expédiée',
    value: 'ready'
  },
  {
    label: 'Donnée au transporteur',
    value: 'given_to_carrier'
  },
  {
    label: 'Scannée par le transporteur',
    value: 'scanned_by_carrier'
  },
  {
    label: 'Livrée',
    value: 'delivered'
  },
  {
    label: 'Livraison échouée',
    value: 'delivery_failed'
  },
  {
    label: 'Retournée',
    value: 'returned'
  },
  {
    label: 'Annulée',
    value: 'cancelled'
  },
  {
    label: 'Perdue',
    value: 'lost'
  }
];

export const receptionFilters = [
  {
    label: 'Non reçue',
    value: 'not_received'
  },
  {
    label: 'Reçue',
    value: 'received'
  },
  {
    label: 'En cours de contrôle',
    value: 'check_in_progress'
  },
  {
    label: 'Bloquée',
    value: 'blocked'
  },
  {
    label: 'Contrôlée',
    value: 'checked'
  },
  {
    label: 'Annulée',
    value: 'cancelled'
  }
];
